import React from 'react';

export default function timeAgoWithUpdates(updatedAt) {
  if (!updatedAt) return 'Invalid date';

  try {
    const fixedUpdatedAt = updatedAt?.split('.')[0] + 'Z';
    const now = new Date();
    const updatedDate = new Date(fixedUpdatedAt);

    // بررسی معتبر بودن تاریخ
    if (isNaN(updatedDate.getTime())) {
      return 'Invalid date';
    }

    const differenceInSeconds = Math.floor((now - updatedDate) / 1000);

    if (differenceInSeconds < 0) {
      return 'Just now';
    }

    if (differenceInSeconds === 0) {
      return 'Just now';
    }

    if (differenceInSeconds < 60) {
      return `${differenceInSeconds} sec${
        differenceInSeconds !== 1 ? 's' : ''
      } ago`;
    }

    const minutes = Math.floor(differenceInSeconds / 60);
    if (minutes < 60) {
      return `${minutes} min${minutes !== 1 ? 's' : ''} ago`;
    }

    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
      return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
    }

    const days = Math.floor(hours / 24);
    return `${days} day${days !== 1 ? 's' : ''} ago`;
  } catch (error) {
    console.error('Error in timeAgoWithUpdates:', error);
    return 'Invalid date';
  }
}

// Hook for automatic time updates
export function useTimeAgoWithUpdates(updatedAt) {
  const [timeDisplay, setTimeDisplay] = React.useState(() =>
    timeAgoWithUpdates(updatedAt)
  );

  React.useEffect(() => {
    if (!updatedAt) {
      setTimeDisplay('Invalid date');
      return;
    }

    // برای زمان‌های خیلی نزدیک، هر 1 ثانیه به‌روزرسانی کن
    const interval = setInterval(() => {
      const newTimeDisplay = timeAgoWithUpdates(updatedAt);
      setTimeDisplay(newTimeDisplay);
    }, 1000);

    return () => clearInterval(interval);
  }, [updatedAt]);

  return timeDisplay;
}
